import { JsonObject, JsonProperty } from 'json2typescript';

import { InitiatorsInterface } from '../../../core';
import { StringAdapter } from '../../client/helpers/serializer/adapters/string.adapter';

@JsonObject('Initiators')
export class Initiators implements InitiatorsInterface {
    @JsonProperty('ClientId', StringAdapter, true)
    private _clientId: string = undefined;

    @JsonProperty('UserId', StringAdapter, true)
    private _userId: string = undefined;

    @JsonProperty('Checked', Boolean, true)
    private _checked: boolean = undefined;

    get ClientId(): string {
        return this._clientId;
    }

    set ClientId(value: string) {
        this._clientId = value;
    }

    get UserId(): string {
        return this._userId;
    }

    set UserId(value: string) {
        this._userId = value;
    }

    get Checked(): boolean {
        return this._checked;
    }

    set Checked(value: boolean) {
        this._checked = value;
    }
}
